export default __webpack_public_path__ + "static/media/bg5.eb0b192f.jpeg";